export * from './add-data.component';
export * from './add-data.module';
